var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_213_4469)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.8724,
    cy: 54.8724,
    r: 54.8724,
    fill: "#2E7161"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7937 66.6122V45.0122H29.9297V66.6122H24.7937ZM16.2977 58.2122V53.4122H38.4257V58.2122H16.2977Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9923 89.0241C76.2529 89.0241 76.3524 88.6772 76.5528 88.4525L88.4992 76.5061C88.7197 76.2609 89.4182 75.0154 89.4182 74.6682C89.4182 74.9337 89.5384 74.4435 89.4182 74.6682V26.8825C89.4182 23.9205 86.4946 21 84.0494 21H46.4495C43.9842 21 42 23.7792 42 26.7412V83.999C42 86.961 44.0043 89.3714 46.4495 89.3714H75.1906C75.4912 89.3714 75.7718 89.2284 75.9723 89.0241H75.9923ZM77.0546 84.8365V79.9135C77.0546 77.8912 78.4375 76.2366 80.1211 76.2366H84.6507L77.0746 84.8365H77.0546ZM73.968 86.4094H46.4495C45.3471 86.4094 44.4652 85.3472 44.4652 84.0194V26.7616C44.4652 25.4542 45.3471 24.3716 46.4495 24.3716H84.0494C85.1518 24.3716 86.0337 25.4338 86.0337 26.7616V72.7231H80.2614C76.794 72.7231 73.968 76.1141 73.968 80.3017V86.4299V86.4094Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6201 41.1833H78.878C79.5595 41.1833 80.1207 40.5092 80.1207 39.6921V37.0161C80.1207 36.199 79.5595 35.5249 78.878 35.5249H51.6201C50.9386 35.5249 50.3774 36.199 50.3774 37.0161V39.6921C50.3774 40.5092 50.9386 41.1833 51.6201 41.1833ZM51.8806 37.3225H78.6375V39.3857H51.8806V37.3225Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6201 50.5185H78.878C79.5595 50.5185 80.1207 49.8444 80.1207 49.0273V46.3513C80.1207 45.5342 79.5595 44.8601 78.878 44.8601H51.6201C50.9386 44.8601 50.3774 45.5342 50.3774 46.3513V49.0273C50.3774 49.8444 50.9386 50.5185 51.6201 50.5185ZM51.8806 46.6577H78.6375V48.7209H51.8806V46.6577Z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1207 58.3627V55.6868C80.1207 54.8697 79.5595 54.1956 78.878 54.1956H51.6201C50.9386 54.1956 50.3774 54.8697 50.3774 55.6868V58.3627C50.3774 59.1798 50.9386 59.8539 51.6201 59.8539H78.878C79.5595 59.8539 80.1207 59.1798 80.1207 58.3627ZM78.6375 58.0563H51.8806V55.9932H78.6375V58.0563Z",
    fill: "#F9F9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_213_4469",
    x: 0,
    y: 0,
    width: 117.745,
    height: 117.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_213_4469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_213_4469",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddArticle);
export default __webpack_public_path__ + "static/media/addArticle.a11db81ad2f5303f29581f41697b9254.svg";
export { ForwardRef as ReactComponent };